<template>
  <page-column>
    <div id="mobile" :style="'overflow-x: hidden;background:' + bgColor">
      <Header :lang="lang"></Header>
      <div>
        <div class="banner-c"><img :src="imageConfig.imageList&&imageConfig.imageList[0].url"></div>
      </div>
      <tabs v-model="active" title-active-color="#0b7ce0" color="#0b7ce0" @click="selectedTab">
        <tab :title="status1(lang)"> </tab>
        <tab :title="status(lang)"> </tab>
      </tabs>
      <div  v-html="detailCompanyInfo.content" class="content-about-mobile"> </div>

    </div>
  </page-column>
</template>
<script>

import Header from '../components/mobile/header.vue'
import { Tabs, Tab } from 'vant';
export default {
  name: 'NewsMobile',
  components: {
    Header,
    Tabs,
    Tab,
  },
  props: {
    lang: {}
  },
  data() {
    return {
      bgColor: '',
      imageConfig:{},
      pageConfigPageTotal: {
        total: null,
        pageSize: 10,
        pageNo: 1,
        pageTotal: null
      },
      font: {},
      active: 0,
      selectedType: 0,
      detailCompanyInfo:{},
      isLoading: false,
      loading: false,
      finished: false,
    }
  },
  mounted() {
    this.getImage()
    this.fetchData()
    this.getFontConfig()
  },
  watch: {
    "$route": "fetchData",
  },
  methods: {
    fetchData() {
      this.getCompanyInfo(this.active)
    },
    selectedTab() {
      this.selectedType = this.active
      this.getCompanyInfo(this.active)
    },
    status(key) {
      var map = {
        'zh': '集团概况',
        'en': 'About Us',
        'ja': '会社概要',
      }
      return map[key]
    },
    status1(key) {
      var map = {
        'zh': '集团历史',
        'en': 'History',
        'ja': 'グループ履歴',
      }
      return map[key]
    },
    async getCompanyInfo(type){
			const res  =  await this.$http.post('groupInfoList',{la:this.lang,type:type})
			this.detailCompanyInfo = res.data.find(v=>v.type===type)||{}
			this.currentType = type
	  },
    async getImage() {
      const res=await this.$http.post('aboutUsConfig',{la:this.lang})
      this.imageConfig = res.data[0]||{}
      this.bgColor = this.imageConfig.bgColor
    },
    getTime(time) {
      const d = time;
      const list = d.split(/[T.]/)
      return list[0];
    },
    async getFontConfig() {
      const res = await this.$http.post('fontConfig')
      const fontContent = res.data
      if (fontContent.length !== 0) {
        this.font = fontContent[0]

      }
    },
    getDetail(news) {
      localStorage.setItem('newsDetailData', JSON.stringify({ id: news._id }))
      this.$router.push("/newsDetail/" + this.lang)
    },
    changePage(page) {
      this.pageConfigPageTotal.pageNo = page;
      this.fetch()
    }
  }
}
</script>
<style >
.content-about-mobile img{
  width: 100%;
}
</style>
<style lang="scss" scoped>
.banner-c {
  height: 6.6rem;

  img {
    margin: 0 auto;
    position: absolute;
    left: 0;
    width: 100%;
  }

}

.content-about-mobile{
  padding:.32rem;
  box-sizing: border-box;
  p{
    width: 100%;

  }
  img{
    width: 100%;
  }
}

.news-list {
  padding: .32rem;
  box-sizing: border-box;

  .l-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .l-content {
    font-size: 13px;
    color: #999;
    height: 21px;
    line-height: 20px;
  }
}
</style>
